import {
  videosList,
  videosFilter,
  livesList,
  myEventsList,
  archivedLivesList,
  myContent,
  profile,
  planDetails,
  billingSettings,
  purchaseHistory,
  myList,
  members,
  userLimits,
  planning,
} from 'config/routes'
import * as config from '../../config'
import { recordingsList } from '../../config/routes'

export const aboutMenu = [
  {
    path: '/about',
    titleKey: 'page.about.submenu.about',
  },
]

export const mainMenu = [
  {
    path: videosList.getPath(),
    titleKey: 'header.menu.vod',
    private: true,
    disabled: state => {
      return !hasAccess(state) || config.IS_LANDING
    },
    children: [
      {
        titleKey: 'header.menu.vod.latest',
        path: videosList.getPath(),
        exact: true,
      },
      {
        titleKey: 'header.menu.vod.politics',
        path: videosFilter.getPath(),
        category: 'politics',
        exact: true,
      },
      {
        titleKey: 'header.menu.vod.society',
        path: videosFilter.getPath(),
        category: 'society',
        exact: true,
      },
      {
        titleKey: 'header.menu.vod.cultural_events',
        path: videosFilter.getPath(),
        category: 'cultural-events-and-celebrations',
        exact: true,
      },
    ],
  },
  {
    path: livesList.getPath(),
    titleKey: 'header.menu.live',
    exact: true,
    private: true,
    disabled: state => {
      return !hasAccess(state) || config.IS_LANDING
    },
    children: [
      {
        titleKey: 'header.menu.live.all_events',
        path: livesList.getPath(),
        exact: true,
        private: true,
      },
      {
        titleKey: 'header.menu.live.my_events',
        path: myEventsList.getPath(),
        exact: true,
        private: true,
      },
      /* {
        titleKey: 'header.menu.live.recordings',
        path: recordingsList.getPath(),
        exact: true,
        private: true,
        disabled: state => {
          return hasNotRecordingsAccess(state)
        },
      }, */
      /* {
        titleKey: 'header.menu.live.archived_events',
        path: archivedLivesList.getPath(),
        exact: true,
        private: true,
      }, */
    ],
  },
  {
    path: '/plans',
    titleKey: 'header.menu.pricing',
    disabled: state => {
      return !hasAccess(state) || config.IS_LANDING
    },
  },
  {
    titleKey: 'page.profile.menu.my_content',
    path: myContent.getPath(),
    exact: true,
    disabled: state => {
      return !hasAccess(state) || !config.IS_LANDING
    },
  },
  {
    path: '/about',
    titleKey: 'footer.link.about',
    exact: true,
    external: true,
    disabled: () => config.IS_LANDING,
    children: [
      {
        path: '/about',
        titleKey: 'header.menu.about',
        exact: true,
        external: true,
      },
      {
        path: '/career',
        titleKey: 'header.menu.careers',
        exact: true,
      },
    ],
  },
  // WP header order: О Раптли, Услуги, Новости. Served outside the SPA (server redirect), like /about.
  {
    path: '/services',
    titleKey: 'header.menu.broadcast',
    exact: true,
    external: true,
    disabled: () => config.IS_LANDING,
  },
  {
    path: '/news',
    titleKey: 'header.menu.news',
    exact: true,
    external: true,
    disabled: () => config.IS_LANDING,
  },
]

export const isClient = state => {
  return state.user.currentUser.payload.user_group === 'client'
}

export const hasNotAgreementsOrMembers = state => {
  return (
    state.user.userLimitsAgreements.payload.length <= 0 ||
    state.user.currentUser.payload.members_count <= 0
  )
}

export const hasAccess = state => {
  return state.user.isSignedIn
}

export const hasNotRecordingsAccess = state => {
  return !(state.user.agreements.payload || []).some(
    agr => agr.status === 'active' && agr.recordings_access
  )
}

export const noHasMembers = state => {
  const user = state.user.currentUser.payload

  return user.members_count <= 0 && user.only_one_off
}

export const userMenu = config.IS_LANDING
  ? [
      {
        titleKey: 'page.profile.menu.my_content',
        path: myContent.getPath(),
        exact: true,
      },
      {
        titleKey: 'page.profile.menu.profile',
        path: profile.getPath(),
      },
      {
        titleKey: 'page.profile.menu.members',
        path: members.getPath(),
        disabled: state => {
          return isClient(state) || noHasMembers(state)
        },
      },
    ]
  : [
      {
        titleKey: 'page.profile.menu.my_content',
        path: myContent.getPath(),
        exact: true,
      },
      {
        titleKey: 'page.profile.menu.profile',
        path: profile.getPath(),
      },
      {
        titleKey: 'page.profile.menu.plan_details',
        path: planDetails.getPath(),
      },
      {
        titleKey: 'page.profile.menu.billing_settings',
        path: billingSettings.getPath(),
        disabled: isClient,
      },
      {
        titleKey: 'page.profile.menu.purchase_history',
        path: purchaseHistory.getPath(),
        disabled: isClient,
      },
      {
        titleKey: 'page.profile.menu.my_lists',
        path: myList.getPath(),
      },
      {
        titleKey: 'page.profile.menu.members',
        path: members.getPath(),
        disabled: state => {
          return isClient(state) || noHasMembers(state)
        },
      },
      {
        titleKey: 'page.profile.menu.user_limits',
        path: userLimits.getPath(),
        disabled: state => {
          return (
            isClient(state) ||
            noHasMembers(state) ||
            hasNotAgreementsOrMembers(state)
          )
        },
      },
      {
        titleKey: 'page.profile.menu.planning',
        path: planning.getPath(),
        disabled: state => !!state.user.planningAccess.error,
      },
    ]
